<div
  class="flex flex-row justify-start items-center gap-x-2"
  [formGroup]="form"
>
  <mat-form-field>
    <mat-label>Type</mat-label>
    <mat-select formControlName="type">
      <mat-option value="email">Email</mat-option>
      <mat-option value="phone">Phone</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{
      form.value.type === 'email' ? 'Email Address' : 'Phone Number'
    }}</mat-label>
    <input matInput formControlName="value" />
  </mat-form-field>
</div>
